import { render, staticRenderFns } from "./CollectionAuth.vue?vue&type=template&id=567ccae2&scoped=true&"
import script from "./CollectionAuth.vue?vue&type=script&lang=js&"
export * from "./CollectionAuth.vue?vue&type=script&lang=js&"
import style0 from "./CollectionAuth.vue?vue&type=style&index=0&id=567ccae2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567ccae2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
